export default __webpack_public_path__ + "static/media/bell.83187ef8.svg";